import React from "react";
import './contact.css';
import PageTemplate from "../../templates/page-template/PageTemplate";
import ContactContent from "../../organisms/ContactContent/ContactContent";

const Contact: React.FC = () => {
    return (
        <PageTemplate children={<ContactContent/>}></PageTemplate>
    );
};

export default Contact;